import ReactDOM from 'react-dom/client';

import { configureAxios } from 'config/axios';

// Use consistent styling
import 'sanitize.css/sanitize.css';
import 'styles/global.css';
import { initAntImagePreviewEnhancements } from 'utils/antImagePreviewEnhancements';
import App from 'app';
import { BrowserRouter } from 'react-router-dom';
import { LoadingProvider } from 'contexts/loading';
import { FlashProvider } from 'contexts/flash';
import { Flash } from './app/components/elements/Flash';
import theme from './styles/theme';
import { ThemeProvider } from '@mui/material';
import { SystemInfoProvider } from 'contexts/systemInfo';
import { AuthProvider } from 'contexts/auth';

configureAxios();
initAntImagePreviewEnhancements();

/**
 * Root App
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <LoadingProvider>
        <AuthProvider>
          <SystemInfoProvider>
            <FlashProvider>
              <App />
              <Flash />
            </FlashProvider>
          </SystemInfoProvider>
        </AuthProvider>
      </LoadingProvider>
    </ThemeProvider>
  </BrowserRouter>
);
